<template>
  <div id="midTop">
    <div class="bg-color-black">
      <myTitle :icon="'chart-bar'">实时电量</myTitle>
      <div>
        <bottomRightTopChart></bottomRightTopChart>
      </div>
    </div>
  </div>
</template>
  
<script>
import bottomRightTopChart from '@/components/power/bottomRight/top'
import myTitle from '@/components/common/title'
export default {
  components: {
    bottomRightTopChart,
    myTitle
  }
}
</script>
  
<style lang="scss" scoped>
$box-height: 300px;
$box-width: 100%;

#midTop {
  padding: 20px 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;

  .bg-color-black {
    height: $box-height - 35px;
    border-radius: 10px;
  }

  .text {
    color: #c3cbde;
  }

  .chart-box {
    margin-top: 16px;
    width: 170px;
    height: 170px;

    .active-ring-name {
      padding-top: 10px;
    }
  }
}
</style>
  